import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';
import { JoinClassResult, LookupClassResult } from './student-class.model';

@Injectable({ providedIn: 'root' })
export class StudentClassHttpService extends SupabaseBaseHttpService<'classes', 'classroom'> {
  readonly schema = 'classroom';
  readonly tableName = 'classes';
  readonly viewName = 'student_classes_list';

  fetchAllFromView() {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.viewName)
        .select('*')
        .throwOnError()
        .then((response) => response.data ?? []),
    );
  }

  fetchBySyllabusContext(syllabusId: number, courseLevel: string | null) {
    let query = this.supabase.client.schema(this.schema).from(this.viewName).select('*').eq('syllabus_id', syllabusId);

    if (courseLevel) {
      query = query.eq('course_level', courseLevel);
    } else {
      query = query.is('course_level', null);
    }

    return from(query.throwOnError().then((response) => response.data!));
  }

  fetchById(id: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.viewName)
        .select('*')
        .eq('id', id)
        .single()
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  lookupClassByEnrollmentCode(code: string): Observable<LookupClassResult | null> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('lookup_class_by_enrollment_code', { p_enrollment_code: code })
        .throwOnError()
        .then((response) => response.data as unknown as LookupClassResult | null),
    );
  }

  joinClassByEnrollmentCode(code: string): Observable<JoinClassResult | null> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('join_class_by_enrollment_code', { p_enrollment_code: code })
        .throwOnError()
        .then((response) => response.data as unknown as JoinClassResult | null),
    );
  }
}
